import { ColumnExtractor } from './column-extractor';

export class ConditionalExtractor implements ColumnExtractor {
	private dataPath: string;

	constructor(
		private condition: (storeData: any) => boolean,
		private trueExtractor: ColumnExtractor,
		private falseExtractor: ColumnExtractor
	) { }

	public extractor(): (storeData: any) => number | string {
		return (storeData: any) => {
			if (this.condition(storeData)) {
				this.dataPath = `True: ${this.trueExtractor.getDataPointPath()}`;
				return this.trueExtractor.extractor()(storeData);
			} else {
				this.dataPath = `False: ${this.falseExtractor.getDataPointPath()}`;
				return this.falseExtractor.extractor()(storeData);
			}
		};
	}

	public getDataPointPath(): string {
		return this.dataPath;
	}
}
